export default "__VITE_ASSET__DuLA30t3__"